import { render, staticRenderFns } from "./TextEdit.vue?vue&type=template&id=1813b8c0&scoped=true&"
import script from "./TextEdit.vue?vue&type=script&lang=js&"
export * from "./TextEdit.vue?vue&type=script&lang=js&"
import style0 from "./TextEdit.vue?vue&type=style&index=0&id=1813b8c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1813b8c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1813b8c0')) {
      api.createRecord('1813b8c0', component.options)
    } else {
      api.reload('1813b8c0', component.options)
    }
    module.hot.accept("./TextEdit.vue?vue&type=template&id=1813b8c0&scoped=true&", function () {
      api.rerender('1813b8c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DesignEditor/component/edit/TextEdit.vue"
export default component.exports